/**
 * @generated SignedSource<<09de94570e5fc38cca3ae7d2b1a7648e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFollowSearchBanner_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"sellerBrandingHelpers_user">;
  readonly " $fragmentType": "SharedFollowSearchBanner_user";
};
export type SharedFollowSearchBanner_user$key = {
  readonly " $data"?: SharedFollowSearchBanner_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFollowSearchBanner_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFollowSearchBanner_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sellerBrandingHelpers_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "92507a1bfbefe595baa725d008c4d96a";

export default node;
